import { Link } from "react-router-dom";
import { LOGO_WHITE } from "@/lib/brand";
import { Twitter, Linkedin, Github, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-brand-navy text-white mt-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <img src={LOGO_WHITE} alt="DraftVoice" className="h-9 w-9 object-contain" />
            <span className="text-xl font-bold">DraftVoice AI</span>
          </div>
          <p className="text-sm text-white/70 max-w-sm leading-relaxed">
            Speak it. We draft it. Premium AI voice writing built for India — English, Hindi, Telugu & Mixed.
          </p>
          <div className="flex gap-3 mt-5">
            {[Twitter, Linkedin, Github, Mail].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold mb-3 text-white/90">Product</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/features" className="hover:text-white">Features</Link></li>
            <li><Link to="/how-it-works" className="hover:text-white">How it works</Link></li>
            <li><Link to="/use-cases" className="hover:text-white">Use cases</Link></li>
            <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold mb-3 text-white/90">Company</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><a href="#" className="hover:text-white">Privacy</a></li>
            <li><a href="#" className="hover:text-white">Terms</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/50">
        © Draft Voice AI | A Product of TheTechHacker by Rahul Vithala.
      </div>
    </footer>
  );
}
